import { OrderChildSource, HDLPublicParm } from './const';
import ccbAppHelper from './Ccb-app-helper';

const Browser = {
  海底捞备用来源五: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLBACKUPFIVE;
    },
    code: OrderChildSource.HDLBACKUPFIVE,
  },

  海底捞备用来源四: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLBACKUPFOUR;
    },
    code: OrderChildSource.HDLBACKUPFOUR,
  },

  海底捞备用来源三: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLBACKUPTHREE;
    },
    code: OrderChildSource.HDLBACKUPTHREE,
  },

  海底捞备用来源二: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLBACKUPTWO;
    },
    code: OrderChildSource.HDLBACKUPTWO,
  },

  海底捞备用来源一: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLBACKUPONE;
    },
    code: OrderChildSource.HDLBACKUPONE,
  },

  海底捞合作来源: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLCOOPERATION;
    },
    code: OrderChildSource.HDLCOOPERATION,
  },

  海底捞公众号HOT: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLHOT;
    },
    code: OrderChildSource.HDLHOT,
  },

  海底捞公众号WS: {
    isChecked: hdlScence => {
      return +hdlScence === HDLPublicParm.HDLWS;
    },
    code: OrderChildSource.HDLWS,
  },
  微信小程序: {
    isChecked: userAgent => {
      return /micromessenger/i.test(userAgent) && /miniProgram/i.test(userAgent);
    },
    code: OrderChildSource.WX_MINI,
  },
  微信: {
    isChecked: userAgent => {
      return /micromessenger/i.test(userAgent) && !/miniProgram/i.test(userAgent);
    },
    code: OrderChildSource.WX,
  },
  支付宝小程序: {
    isChecked: userAgent => {
      return /AliApp|AlipayDefined|AlipayClient/i.test(userAgent) && /miniProgram/i.test(userAgent) && userAgent.indexOf('KoubeiClient') === -1;
    },
    code: OrderChildSource.ALIPAY_MINI,
  },
  支付宝: {
    isChecked: userAgent => {
      return /AliApp|AlipayDefined|AlipayClient/i.test(userAgent) && !/miniProgram/i.test(userAgent) && userAgent.indexOf('KoubeiClient') === -1;
    },
    code: OrderChildSource.ALIPAY,
  },

  口碑: {
    isChecked: userAgent => {
      return userAgent.indexOf('KoubeiClient') !== -1;
    },
    code: OrderChildSource.KOUBEI,
  },

  海底捞: {
    isChecked: userAgent => {
      return userAgent.indexOf('Haidilao') !== -1;
    },
    code: OrderChildSource.HDL,
  },

  招行: {
    isChecked: userAgent => {
      const str = userAgent ? (userAgent + '').toLocaleLowerCase() : '';
      return str.indexOf('cmb') !== -1 || str.indexOf('cmblife') !== -1;
      // return userAgent.indexOf('CMB') !== -1 || userAgent.indexOf('cmb') !== -1 || userAgent.indexOf('CMBLIFE') !== -1 || userAgent.indexOf('cmblife') !== -1;
    },
    code: OrderChildSource.CMB,
  },
  建设银行App: {
    isChecked: userAgent => {
      return ccbAppHelper.isCcbEvn(userAgent);
    },
    code: OrderChildSource.CCB_APP,
  },
};

exports.getBrowserCode = (realUserAgent = navigator.userAgent) => {
  const userAgent = realUserAgent;
  let childSource = OrderChildSource.OTHER;

  Object.keys(Browser).some(key => {
    if (Browser[key].isChecked(userAgent)) {
      childSource = Browser[key].code;
      return true;
    }

    return false;
  });

  return childSource;
};



// WEBPACK FOOTER //
// ./src/helper/order-source-helper.js